define.alias("ember-math-helpers/helpers/asinh", "settings/helpers/asinh");